import React, { useState } from 'react';
import NewsOne from './assets/boardmembers-1.jpg';
import NewsTwo from './assets/news-2.png';
import NewsThree from './assets/news-3.png';
import NewsFour from './assets/news-4.png';
import NewsSeven from './assets/ISOT.jpg'
import NewsEight from './assets/IWD-1.jpg'
import NewsNine from './assets/AgCEOVisit-1.jpg'
import NewsTen from './assets/BoardImage.jpg'
import NewsEleven from './assets/Notice.jpg'
import NewsTwelve from './assets/piac.jpg'
import NewsThirteen from './assets/Parliament.jpg'
import NewsFourteen from './assets/TemaOfftakers-1.jpg'
import NewsFifteen from './assets/CEOAward.jpg'


import { Link } from 'react-router-dom';
import {
  TbSquareArrowRightFilled,
  TbSquareArrowLeftFilled,
} from "react-icons/tb";

const images = [
  { id: 14, src: NewsFifteen, title: "Ms. Judith Adjobah Blay Honoured For Her Leadership In Ghana’s Energy Sector", link: '/news/CEOLeadership',},
  { id: 13, src: NewsFourteen, title: "Ghana Gas CEO engages with gas off-takers in Tema as it seeks to boost gas supply to industry", link: '/news/TemaOfftakers',},
  { id: 13, src: NewsThirteen, title: "GNGLC engages Parliament’s Energy Committee on 2025 strategic work plan.", link: '/news/ParliamentEngagement',},
  { id: 12, src: NewsTwelve, title: "PIAC delegation visits Ghana Gas to strengthen partnership", link: '/news/PIACVisit',},
  { id: 11, src: NewsEleven, title: "ALL SPONSORSHIPS from the company have been put ON HOLD until further notice.", link: '/news/Notice',},
  { id: 10, src: NewsTen, title: "New Ghana Gas Board Embarks On Familiarization Tour Of Western Region Facilities", link: '/news/BoardVisit', },
  { id: 9, src: NewsNine, title: "CEO embarks on a three-day working visit to the Western Region", link: '/news/AgCEOVisit', },
  { id: 8, src: NewsEight, title: "Ghana Gas celebrates International Women’s Month", link: '/news/IWD', },
  { id: 7, src: NewsSeven, title: "Ghana Gas achieves ISO 14001 and ISO 45001 certifications", link: '/news/ISOCertifications', },
  { id: 1, src: NewsOne, title: "New Board Members Appointed To Ghana National Gas Limited Company", link: '/news/BoardMembers', },
  { id: 2, src: NewsTwo, title: "Ghana Gas celebrates 10 years anniversary" },
  { id: 3, src: NewsThree, title: "Ghana National Gas Company grabs four prestigious awards" },
  { id: 4, src: NewsFour, title: "Ghana Gas supports Olympian" },
  { id: 6, src: NewsTwo, title: "Ghana Gas celebrates 10 years anniversary" }
];

const App = () => {
  const [visibleImages, setVisibleImages] = useState([
    images[0],
    images[1],
    images[2],
    images[3],
  ]);
  const [currentIndex, setCurrentIndex] = useState(0);

  const showNextImages = () => {
    // Calculate the next set of images in a loop
    const nextIndex = (currentIndex + 1) % images.length;
    const nextImages = [
      images[nextIndex],
      images[(nextIndex + 1) % images.length],
      images[(nextIndex + 2) % images.length],
      images[(nextIndex + 3) % images.length],
    ];

    setVisibleImages(nextImages);
    setCurrentIndex(nextIndex);
  };

  const showPreviousImages = () => {
    // Calculate the previous set of images in a loop
    const previousIndex = (currentIndex - 1 + images.length) % images.length;
    const previousImages = [
      images[previousIndex],
      images[(previousIndex + 1) % images.length],
      images[(previousIndex + 2) % images.length],
      images[(previousIndex + 3) % images.length],
    ];

    setVisibleImages(previousImages);
    setCurrentIndex(previousIndex);
  };

  return (
    <div className="flex flex-col mt-3 small-laptop:mt-1">
      <div className='flex flex-row justify-between items-center'>
        <h1 className='font-fira text-2xl pl-4 small-laptop:text-3xl'>Latest News</h1>
        <div className='flex pr-4'>
          <TbSquareArrowLeftFilled
            onClick={showNextImages}
            className='h-7 w-7 cursor-pointer'
          />
          <TbSquareArrowRightFilled onClick={showPreviousImages} className='h-7 w-7 cursor-pointer' />
        </div>
      </div>
      <div className="flex flex-col sm:flex-row w-full md:space-x-8 p-4">
        {visibleImages.map((image) => (
          <Link
            key={image.id}
            to={image.link}
            className="flex flex-col sm:w-1/4 hover:opacity-90 transition duration-200"
          >
            <img src={image.src} alt={`Image ${image.id}`} />
            <h1 className='font-fira text-lg sm:text-xl'>
              {image.title}
            </h1>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default App;




